import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CreateDocumentPage from './pages/CreateDocumentPage';
import DocumentDetailPage from './pages/DocumentDetailPage';
import ApiDocsPage from './pages/ApiDocsPage';
import SignaturePadApp from './components/SignaturePadApp';
import SigningInterface from './components/SigningInterface';
import SigningSpacePage from './pages/SigningSpacePage';
import './App.css';

// Protected route wrapper — redirects to /login if not authenticated
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
    </div>
  );
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Public route wrapper — redirects to /dashboard if already authenticated
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          
          <Route path="/api-docs" element={<ApiDocsPage />} />
          
          {/* Signing routes (no auth — accessed via email link) */}
          <Route path="/sign/:token" element={<SigningInterface />} />
          <Route path="/signature/:sessionToken" element={<SignaturePadApp />} />

          {/* Protected routes */}
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/documents/new" element={<ProtectedRoute><CreateDocumentPage /></ProtectedRoute>} />
          <Route path="/documents/:id" element={<ProtectedRoute><DocumentDetailPage /></ProtectedRoute>} />
          <Route path="/signing-space/:documentId" element={<ProtectedRoute><SigningSpacePage /></ProtectedRoute>} />
          <Route path="/signing-space/bundle/:bundleId" element={<ProtectedRoute><SigningSpacePage /></ProtectedRoute>} />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
